import React from "react";
import { Loading } from "../../components/Loading";
import useCarsServiceReport from "../../hooks/useCarsServiceReport";
import { Header } from "../../components/Header";
import { Table } from "antd";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import FilterCarsServiceReport from "./FilterCarsServiceReport/FilterCarsServiceReport";
import PlateNumberComponent from "../../components/PlateNumberComponent";

export const CarsServiceReport = () => {
  const {
    loading,
    carsServiceReport,
    provinces,
    cities,
    setCities,
    categories,
    users,
    getCarsServiceReport,
    form,
    search,
    setSearch,
    cars,
    changePage,
    getUsers,
    exportCarServicesReport,
  } = useCarsServiceReport();
  const { Column } = Table;

  return (
    <>
      <Header
        title="Cars Service Report"
        activeItem="CarsServiceReport"
        leftTitle={`Total Services: ${carsServiceReport?.length || 0}`}
      />
      <ContentCard
        filter={
          <FilterCarsServiceReport
            categories={categories}
            cities={cities}
            setCities={setCities}
            provinces={provinces}
            getCarsServiceReport={getCarsServiceReport}
            exportCarServicesReport={exportCarServicesReport}
            users={users}
            cars={cars?.data || []}
            form={form}
            search={search}
            setSearch={setSearch}
            getUsers={getUsers}
          />
        }
      >
        <Loading isLoading={loading}>
          <Table
            size="small"
            scroll={{ x: 1800 }}
            dataSource={carsServiceReport || []}
            pagination={{
              position: ["bottomCenter"],
              current: 1,
              pageSize: 10,
              total: 5,
              onChange: changePage,
            }}
          >
            <Column
              title="#"
              dataIndex="index"
              key="index"
              render={(_value, _item, index) => <>{index + 1}</>}
            />

            <Column
              title="City"
              dataIndex="address"
              key="address"
              render={(address) => (
                <>
                  <small className="color-promotion-s1 mr-10 ml-5">
                    [{address.province}]
                  </small>
                  <span className="mx-10">{address.city}</span>
                </>
              )}
            />
            <Column
              title="Operator"
              dataIndex="operator"
              key="operator"
              render={(operator) => operator?.operator_name || "-"}
            />
            <Column
              title="Car Name"
              dataIndex="user_car"
              key="user_car"
              render={(user_car) => <>{user_car?.car_name || "-"}</>}
            />
            <Column
              title="Plate Number"
              dataIndex="user_car"
              key="user_car"
              render={(user_car) => user_car?.plate_number}
            />
            <Column
              title="Driver Phone Number"
              dataIndex="user"
              key="user"
              render={(user) => <>{user.driver_phone_number}</>}
            />
            <Column
              title="Driver Name"
              dataIndex="user"
              key="user"
              render={(user) => (
                <>
                  {user?.first_name} {user?.last_name}
                </>
              )}
            />
            <Column
              title="Product Category"
              dataIndex="product"
              key="product"
              render={(product) => <>{product.category}</>}
            />
            <Column
              title="Product"
              dataIndex="product"
              key="product"
              render={(product) => <>{product.name}</>}
            />
            <Column
              title="Quantity"
              dataIndex="product"
              key="product"
              render={(product) => product.quantity}
            />
            <Column
              title="Service Center"
              dataIndex="service_center"
              key="service_center"
              render={(service_center) => <>{service_center?.name}</>}
            />
            <Column
              title="Delivery Date"
              dataIndex="delivery_date"
              key="delivery_date"
              render={(delivery_date) => delivery_date || "-"}
            />
            <Column
              title="Visit Date"
              dataIndex="visit_date"
              key="visit_date"
              render={(visit_date) => visit_date || "-"}
            />

            <Column
              title="Current KM"
              dataIndex="km"
              key="km"
              render={(km) => km}
            />
            <Column
              title="Next KM"
              dataIndex="km"
              key="km"
              render={(km) => km}
            />
            <Column title="Delay KM" dataIndex="km" key="km" render={() => 0} />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
